import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import { useAppDispatch } from "@/store";
import { fetchCurrentUser } from "@/store/authSlice";
import { useNotification } from "@/context/NotificationContext";
import { extractErrorMessage } from "@/api/axios";
import * as usersApi from "@/api/users.api";
import { documentTitlePage } from "@/constants/app";
import { hr } from "@/constants/strings.hr";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { notifyIfUsernameInvalid } from "@/utils/username";

export function UsernameSetupPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { notify } = useNotification();
  const [username, setUsername] = useState("");
  const [saving, setSaving] = useState(false);

  useDocumentTitle(documentTitlePage(hr.usernameSetup.documentTitle));

  const handleSubmit = async () => {
    if (!notifyIfUsernameInvalid(username, notify)) return;
    setSaving(true);
    try {
      await usersApi.updateMyUsername(username);
      dispatch(fetchCurrentUser());
      notify(hr.usernameSetup.success, "success");
      navigate("/");
    } catch (err) {
      notify(extractErrorMessage(err), "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        mx: "auto",
        mt: 8,
        textAlign: "center",
      }}
    >
      <Card variant="outlined">
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" sx={{ mb: 1 }}>
            {hr.usernameSetup.welcome}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mb: 3,
            }}
          >
            {hr.usernameSetup.hint}
          </Typography>
          <TextField
            fullWidth
            placeholder={hr.usernameSetup.placeholder}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            fullWidth
            onClick={handleSubmit}
            disabled={saving || !username.trim()}
          >
            {hr.common.save}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
